module.exports = __webpack_public_path__ + "img/Fresh & Fruity.b3eab2fa.jpg";